import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Mail, Globe, Shield, Cookie, Heart, 
  Twitter, Facebook, Instagram, Youtube, FileText 
} from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-950 to-black text-gray-300 border-t border-gray-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand & About */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-emerald-600/30 p-2.5 rounded-xl flex items-center justify-center">
                <img
                  src="/Hirez.png"
                  alt="AFCON 2025 Logo"
                  className="w-9 h-9 object-contain scale-110"
                />
              </div>
              <h3 className="text-2xl font-bold text-white">AFCON 2025</h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Your #1 source for TotalEnergies Africa Cup of Nations 2025 Morocco — live scores, highlights, stats & more.
            </p>
            <p className="text-xs text-gray-500">
              Not affiliated with CAF or official AFCON organizers
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-5 uppercase tracking-wider text-sm">Navigation</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/matches" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                  Matches
                </Link>
              </li>
              <li>
                <Link to="/teams" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                  Teams & Groups
                </Link>
              </li>
              <li>
                <Link to="/highlights" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                  Highlights
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-5 uppercase tracking-wider text-sm">Legal</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center gap-2">
                  <Shield size={16} />
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center gap-2">
                  <Shield size={16} />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center gap-2">
                  <Cookie size={16} />
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-500">
          <p className="flex items-center justify-center gap-1">
            Made with <Heart size={16} className="text-red-500 fill-red-500" /> for African Football
          </p>
          <p className="mt-2">
            © {currentYear} AFCON 2025 Morocco Coverage • All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};